module.exports = __webpack_public_path__ + "img/qr.bc6a71f9.png";